import {
  _BaseCssVarInjectProps as BCVIProps,
  _SelfMap as SelfMap,
  _SubMapMap as SubMapMap,
  _SubjoinSub as SubjoinSub,
  _GetCssVarByClass,
  _KeyRequired
} from './type'
import {
  Base,
  Component,
  InjectReactive,
  Prop,
  Watch
} from '@/vue-property-decorator'
import { _BaseCssVarValue as BaseCssVarValue } from './baseCssVarValue'
import { styleAppendCssVar } from '../util/styleAppendCssVar'
export { BaseCssVarValue }
export type GetCssVarByClass<T> = _GetCssVarByClass<T>
export type KeyRequired<T> = _KeyRequired<T>
/** cssVar注入的子类能复用的就仅有一个InjectReactive,感觉没有太大的引入的必要,但是也是可以引入 */
@Component({
  name: 'BaseCssVarInject'
})
export default class BaseCssVarInject<
  // eslint-disable-next-line @typescript-eslint/ban-types
  M extends SelfMap = { cssType: string },
  // eslint-disable-next-line @typescript-eslint/ban-types
  Sub extends SubMapMap = {}
> extends Base<unknown, BCVIProps<SubjoinSub<M, Sub>, M['cssType']>> {
  /** 父级传递下来的样式管理,通过该属性将该组件转换为受控组件 */
  @InjectReactive({ from: 'compCssVarMapper', default: () => ({}) })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected compCssVarMapper!: Record<string, any>

  /** 样式管理,当组件受控时,它将失效 */
  @Prop() protected cssVarManager: BCVIProps<
    SubjoinSub<M, Sub>,
    M['cssType']
  >['cssVarManager']
  /** 样式管理,当组件受控时,它也不会失效 */
  @Prop() protected cssVarManagerMust: BCVIProps<
    SubjoinSub<M, Sub>,
    M['cssType']
  >['cssVarManagerMust']

  /** 只要父级有,就以父级的优先,父级没有的话,就使用自身的 */
  protected get cssControl(): {
    from: 'father' | 'self'
  } & BCVIProps<SubjoinSub<M, Sub>, M['cssType']>['cssVarManager'] {
    /** 组件自身的名字,首字母换成小写用来做mapper的key */
    let name = this.$options.name || ''
    name = name.charAt(0).toLowerCase() + name.slice(1)
    /** 父级控制下,该组件的CssVar */
    const myCssManager = this.compCssVarMapper?.[name]
    if (myCssManager !== undefined) {
      return Object.assign(
        {
          from: 'father'
        },
        myCssManager,
        this.cssVarManagerMust
      )
    } else {
      return Object.assign(
        {
          from: 'self'
        },
        this.cssVarManager,
        this.cssVarManagerMust
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ) as any
    }
  }
  /** 取一下值,方便使用 */
  protected get finialCssType() {
    // 显示声明一下,它是必有值的,不能是undefined
    return this.cssControl.cssType as M['cssType']
  }

  @Watch('cssControl', { immediate: true })
  watchCssControl() {
    this.$nextTick(() => {
      const rootDom = this.$el as unknown as HTMLElement
      if (!rootDom) {
        // 异常提示,BaseCssVarInject组件中没有dom异常
        return console.error('<BaseCssVarInject> not possess Dom')
      }
      /** 默认是不进行赋值操作 */
      let isRunAppendCssVar = false
      // 满足相应的条件,则要进行赋值操作
      const { from, cssType, ...cssVar } = this.cssControl
      // 来源是父级的,则只在有cssType的时候才渲染cssVar,没有cssType的时候,不渲染cssVar.因为cssVar会在最上层设置,此处不再需要每一个都遍历赋值
      if (from === 'father' && cssType) {
        isRunAppendCssVar = true
      }
      // 来源是自身的cssVar,说明并没有父级,会控制这个变量,也就没有更上层可以挂载变量,则不管类型是什么,都需要赋值.
      if (from === 'self') {
        isRunAppendCssVar = true
      }
      if (!isRunAppendCssVar) {
        return
      }
      const style = rootDom.style
      // 赋值css变量,作为子类,仅赋值自己这一层就行了,因为这种cssVarRigid是无法覆盖底层的css样式的,所以必须主动传给每一个层级.
      styleAppendCssVar({
        style,
        cssMap: cssVar,
        isRecursive: false
      })
    })
  }
}
